import { useState, useRef } from 'react'
import { getMembersForDepartment } from '../../services/util'

export function AddMemberDepartment({ addMember, allMembers, department }) {
    const [isOpen, setIsOpen] = useState(false)
    const [selectedMembers, setSelectedMembers] = useState({})
    const available = useRef(getMembersForDepartment(department.members, allMembers))

    useRef(() => {
        available.current = getMembersForDepartment(department.members, allMembers)
    }, [department.members])

    const handleToggle = (id) => {
        let newMembers = { ...selectedMembers }
        if (newMembers[id]) delete newMembers[id]
        else newMembers[id] = true
        setSelectedMembers(newMembers)
    }

    const onAddMembers = async (ev) => {
        ev?.preventDefault()
        await addMember(Object.keys(selectedMembers), department.name)
        setIsOpen(false)
    }

    if (!isOpen) return <p className='clickable noselect btn arise' onClick={() => setIsOpen(true)}>הוסף חברי צוות +</p>

    return <>
        <p className='clickable noselect btn arise' onClick={() => setIsOpen(false)}>סגור</p>
        <form className='send-invite' onSubmit={onAddMembers}>
            <div className="roles-checkboxes" style={{ marginBottom: '20px' }}>
                {available.current.map((member) => <label className='opt-wrapper' key={member._id}>
                    <input
                        type="checkbox"
                        checked={selectedMembers[member._id] || false}
                        onChange={() => handleToggle(member._id)}
                    />
                    <p>{member.name}</p>
                </label>)}
            </div>
            <button className='arise'>הוסף</button>
        </form>
    </>
}